/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type OrganizationsDestroyRequest = {} | null | undefined;
export type OrganizationsDestroyResponse = any;

export type OrganizationsDestroyQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this organization.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * DELETE /dmx-server/organizations/{id}/
 *
 * ```yaml
 * operationId: organizations_destroy
 * tags:
 *   - organizations
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 * ```
 */
export const organizationsDestroyOperation = ({ id, ...rest }: OrganizationsDestroyQuery) =>
  ({
    method: 'DELETE',
    path: `/dmx-server/organizations/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'DELETE';
    path: string & { _templateUrl: '/dmx-server/organizations/{id}/' };
  };

/**
 * DELETE /dmx-server/organizations/{id}/
 *
 * ```yaml
 * operationId: organizations_destroy
 * tags:
 *   - organizations
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 * ```
 */
export const organizationsDestroy = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: OrganizationsDestroyQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = organizationsDestroyOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'DELETE',
    request,
    onUploadProgress,
    cancelToken,
  );
};
